import { captureMessage } from '@sentry/node';
import type { Response } from 'express';

import { USER_CHANGE_AGREEMENT_ROUTE } from '@r1-frontend/shared/constants/routes';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

export const redirectToChangeAgreementPage = (res?: Response) => {
    if (isServerSide()) {
        if (!res) {
            const errorMessage = 'функция redirectToChangeAgreementPage была вызвана без параметра Response на серверной стороне';
            captureMessage(errorMessage, { level: 'error' });
            console.error(errorMessage);
            return;
        }

        res.redirect(`${USER_CHANGE_AGREEMENT_ROUTE}?referrer=${res.req.url}`);
    } else {
        window.location.replace(`${USER_CHANGE_AGREEMENT_ROUTE}?referrer=${location.href}`);
    }
};
